"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var selectPaymentAmountStyles = makeStyles_1.default(function (_a) {
    var _b;
    var palette = _a.palette, spacing = _a.spacing, breakpoints = _a.breakpoints;
    return ({
        container: {
            position: 'relative',
        },
        radioGroupContainer: (_b = {
                alignItems: 'stretch',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                paddingTop: spacing(5),
                paddingBottom: spacing(7)
            },
            _b[breakpoints.down('xs')] = {
                flexDirection: 'column',
                width: '95%',
            },
            _b),
        controlLabel: {
            border: "1px solid " + palette.primaryDisabled.main,
            padding: '5px 10px',
            flexGrow: 2,
            justifyContent: 'space-between',
            fontWeight: 700,
            '&$checked': {
                border: "1px solid " + palette.secondary.main,
            },
        },
        reserveFeeControlLabel: {},
        fullFeeControlLabel: {},
        controlRadioButton: {},
        radio: {
            color: palette.primaryDisabled.main,
        },
        amount: {
            fontWeight: 300,
            fontSize: '14px',
            color: palette.primaryDisabled.main,
        },
        checked: {},
    });
}, { name: 'Checkout4_SelectPaymentAmount' });
exports.default = selectPaymentAmountStyles;
